import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className='footer' style={footerStyle}>
      <hr/>
      <div className='row'>
        <div className='col-md-4 mb-3'>
          <h3>Quick Links</h3>
          <ul>
            <li><Link href="#">Men</Link></li>
            <li><Link href="#">Womens</Link></li>
          </ul>
        </div>
        <div className='col-md-4 mb-3'>
          <h3>About</h3>
          <ul>
            <li><Link href="#">Contact Us</Link></li>
            <li><Link href="#">Our Story</Link></li>
          </ul>
        </div>
        <div className='col-md-4 mb-3'>
          <h3>Information</h3>
          <ul>
            <li><Link href="#">Return & Exchange Policy</Link></li>
            <li><Link href="#">Shipping & Delivery Policy</Link></li>
            <li><Link href="#">Terms & COnditions</Link></li>
            <li><Link href="#">Privacy Policy</Link></li>
            <li><Link href="#">Cancellation Policy</Link></li>
            <li><Link href="#">Customozied Policy</Link></li>
            <li><Link href="#">Important Information</Link></li>
            <li><Link href="#">Track Order</Link></li>
            <li><Link href="#">Return & Exchanges</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

// Simple inline styles for the footer
const footerStyle = {
  backgroundColor: '#fff',
  color: '#000',
  padding: '2rem'
};

export default Footer;
